import { render } from "./Error404.vue?vue&type=template&id=da4c639c&scoped=true"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"

import "./Error404.vue?vue&type=style&index=0&id=da4c639c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4c639c"]])

export default __exports__